import createPage from "@src/components/page"
import React from "react"
import logoJson from "@images/lottieJson/2021.json"
import circleJson from "@images/lottieJson/circle.json"
import LottieControl from "@src/components/lottie"
import * as styles from "./pageWelcome.module.scss"
import tagImg from "@images/png/1.png"
import heImg from "@images/png/2.png"
import { useEnteringTrail, callYou } from "@src/components/page/lib"
import { animated } from "react-spring"
import { useContext } from "react"
import AppContext from "@src/context/appContext"
import bgImg from "@images/2022/p1/bg.jpg"
import themeImg from "@images/2022/p1/2.png"
import icon1Img from "@images/2022/p1/3.png"
import icon2Img from "@images/2022/p1/4.png"
import icon3Img from "@images/2022/p1/5.png"
import icon4Img from "@images/2022/p1/6.png"
import icon5Img from "@images/2022/p1/7.png"
import icon6Img from "@images/2022/p1/8.png"
import icon7Img from "@images/2022/p1/9.png"
import startBtnImg from "@images/2022/p1/10.png"
import Clickable from "@src/components/clickable"
import PagesContext from "@src/context/pagesContext"

const tip = (data, { currentUser, queryToken }) => {
  if (!data) {
    if (queryToken) {
      return "无法找到\nTA的\n年度报告"
    }
    if (currentUser) {
      return `无法找到\n${currentUser.attributes?.nickname}的年度报告`
    }
    return "无法找到\n年度报告"
  }
  return `${callYou(data)}与\n机核的\n2022`
}

const PageWelcome = createPage(
  ({ offset, data }) => {
    const { currentUser, queryToken } = useContext(AppContext)
    const { next } = useContext(PagesContext)
    const anime1Styles = useEnteringTrail(1, offset)
    const anime2Styles = useEnteringTrail(2, offset, { step: 0.4, type: "mlt" })
    const anime3Styles = useEnteringTrail(2, offset, { step: 0.4, type: "mrt" })
    const anime4Styles = useEnteringTrail(3, offset, { step: 0.6 })
    const anime5Styles = useEnteringTrail(2, offset, { step: 0.9, type: "mb" })
    return (
      <>
        <div className={styles.container}>
          <animated.img
            src={themeImg}
            alt="theme logo"
            style={anime1Styles[0]}
            className={styles.theme}
          />
          <animated.img
            src={icon1Img}
            alt="icon"
            style={anime2Styles[0]}
            className={styles.icon1Img}
          />
          <animated.img
            src={icon2Img}
            alt="icon"
            style={anime3Styles[0]}
            className={styles.icon2Img}
          />
          <animated.img
            src={icon3Img}
            alt="icon"
            style={anime2Styles[1]}
            className={styles.icon3Img}
          />
          <animated.img
            src={icon4Img}
            alt="icon"
            style={anime3Styles[1]}
            className={styles.icon4Img}
          />
          <animated.img
            src={icon5Img}
            alt="icon"
            style={anime4Styles[0]}
            className={styles.icon5Img}
          />
          <animated.img
            src={icon6Img}
            alt="icon"
            style={anime4Styles[1]}
            className={styles.icon6Img}
          />
          <animated.img
            src={icon7Img}
            alt="icon"
            style={anime4Styles[2]}
            className={styles.icon7Img}
          />
          <span></span>
        </div>
        <animated.h1 className={styles.title} style={anime5Styles[0]}>
          {tip(data, { currentUser, queryToken })}
        </animated.h1>
        <animated.div className="bottomText" style={anime5Styles[1]}>
          <Clickable
            onClick={() => {
              next()
            }}
            className={styles.startButton}
          >
            <img src={startBtnImg} alt="start button" />
          </Clickable>
          <br />
          生成数据截止于 2022 年 12 月中旬
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  },
  {
    showShare: true,
  }
)

export const pageWelcomeData = {
  key: "welcome",
  bgImg,
  Page: PageWelcome,
}

export default PageWelcome
